import queryString from 'query-string'
import humps from 'humps'
import apiClient from './api-client'

function list({
  page,
  practiceId,
  deviceTypeId,
  deviceModelManufacturer,
  matched,
  includeReviewed,
  q,
  birthDate,
  perPage,
  medicalProviderId,
  officeLocationId,
}) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: 'v2/transmissions',
      query: humps.decamelizeKeys({
        page,
        practiceId,
        deviceTypeId,
        deviceModelManufacturer,
        matched,
        reviewed: includeReviewed ? 'all' : 'false',
        birthDate,
        q,
        perPage,
        medicalProviderId,
        officeLocationId,
      }),
    }),
    { withHeaders: true },
  )
}

function connectivity({ page, perPage, practiceId, manufacturer } = {}) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: 'v2/transmissions/connectivity',
      query: humps.decamelizeKeys({
        page,
        perPage,
        practiceId,
        manufacturer:
          manufacturer && manufacturer !== 'all' ? manufacturer : undefined,
      }),
    }),
    { withHeaders: true },
  )
}

function connectivityAlerts({ page, perPage } = {}) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: 'v2/transmissions/connectivity/alerts',
      query: humps.decamelizeKeys({ page, perPage }),
    }),
    { withHeaders: true },
  )
}

function resolveConnectivityAlert(id) {
  return apiClient.destroy(`v2/transmissions/connectivity/alerts/${id}`)
}

function get(id = {}) {
  return apiClient.get(
    queryString.stringifyUrl({ url: `v2/transmissions/${id}` }),
  )
}

function update(id, data) {
  return apiClient.patch(`v2/transmissions/${id}`, data)
}

function dismiss(id) {
  return apiClient.patch(`v2/transmissions/${id}/dismiss`)
}

function archive(id) {
  return apiClient.patch(`v2/transmissions/${id}/archive`)
}

function create(data) {
  return apiClient.post('v2/transmissions/uploads', data)
}

function reportExtractionError(id, data) {
  const payload = {
    ...data,
    errorFields: data.errorFields.map(f => humps.decamelize(f)),
  }

  return apiClient.post(`v2/transmissions/extractions/${id}/errors`, payload)
}

export default {
  list,
  connectivity,
  connectivityAlerts,
  resolveConnectivityAlert,
  get,
  update,
  archive,
  create,
  dismiss,
  reportExtractionError,
}
